import { type HttpHandler, http, HttpResponse } from 'msw';

import type {
  FleetStartVerificationRequest,
  FleetStartVerificationResponse,
  FleetRef,
} from '../../../domain/fleet-verification';

const createFleetVerificationApplicationHandler = (isError?: boolean) =>
  http.post<never, FleetStartVerificationRequest, FleetStartVerificationResponse>(
    '/fleet-verification/start-verification',
    () => {
      if (isError) {
        throw new HttpResponse(null, { status: 400 });
      }

      return HttpResponse.json({ applicantId: 'appl_mock' });
    },
  );

const getFleetsHandler = (fleets?: FleetRef[]) =>
  http.get<never, never, FleetRef[]>('/fleet-verification/fleets', () => {
    return HttpResponse.json(
      fleets ?? [
        {
          id: 'flt_101',
          name: 'Cobra Kai',
          status: 'not_started',
        },
        {
          id: 'flt_102',
          name: 'Eagle Fang Karate',
          status: 'in_progress',
        },
      ],
    );
  });
const handlers: HttpHandler[] = [createFleetVerificationApplicationHandler(), getFleetsHandler()];

export { handlers };
